<template>
  <pn-button
    label="Add Key"
    :icon="plus_circle"
    left-icon="true"
    type="button"
    class="add-key"
    @click="handleAdddButtonClick"
  ></pn-button>
  <div class="config-table">
    <pn-table bordered="true">
      <table style="width: 100%">
        <thead>
          <tr>
            <th><span>KEY</span></th>
            <th>Value</th>
            <th colspan="3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="3" v-if="Object.keys(data).length === 0">
            <td colspan="3" class="text-center">No Records Found</td>
          </tr>
          <tr v-for="(value, key) in data" :key="key">
            <td>
              <span>{{ key }}</span>
            </td>
            <td>{{ value }}</td>
            <td>
              <pn-button
                small
                variant="outlined"
                appearance="light"
                :icon="trash_can"
                tooltip="Delete Key"
                icon-only="true"
                @click="handleDeleteButtonClick(String(key))"
              />

              <pn-button
                small
                variant="outlined"
                appearance="light"
                :icon="edit"
                tooltip="Edit Value"
                icon-only="true"
                @click="handleEditButtonClick(String(key), value)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import { edit, trash_can, plus_circle } from "pn-design-assets/pn-assets/icons";

const props = defineProps<{
  data: any;
}>();

const { data } = toRefs(props);

const emit = defineEmits<{
  (e: "onDeleteAction", key: string): void;
  (e: "onEditAction", config: Record<string, any>): void;
  (e: "onAddKey"): void;
}>();

const handleDeleteButtonClick = (key: string) => {
  emit("onDeleteAction", key);
};

const handleEditButtonClick = (key: string, value: any) => {
  emit("onEditAction", { key: key, value: value });
};

const handleAdddButtonClick = () => {
  emit("onAddKey");
};
</script>

<style scoped>
.config-table {
  display: flex;
  width: 0cqmax;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  width: 100%;
}

.add-key {
  margin-top: 2rem;
  margin-bottom: 1rem;
  float: right;
}

.config-table pn-table {
  width: 100%;
}
</style>
